import React from 'react';

import './category-box-loading.less';

export const LOADING_ELEMENT_KEYS = ['a', 'b', 'c', 'd'];

const CategoryBoxLoading = () => (
  <div className="category-box-loading__container">
    {
      LOADING_ELEMENT_KEYS.map(key => (
        <div className="category-box-loading__category-box" key={key} data-test-group="category-loading">
          <div className="placeholder-box category-box-loading__box-image" />
          <div className="placeholder-box category-box-loading__box-title" />
          <div className="placeholder-box category-box-loading__box-paragraph" />
        </div>
      ))

    }
  </div>
);

export default CategoryBoxLoading;



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/CategoryBoxLoading.jsx